import styled from 'styled-components';

export const StyledItem = styled.img`
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;
